import dayjs from "dayjs";
// import { err, ok, Result } from "neverthrow";
// import { Comment } from "../types/HotelReservation";
// import { ErrorResponse } from "./ErrorResponse";

export const PREFIX = "BLUEPIN SYSTEM GENERATED COMMENT";

export interface IBpSystemGeneratedComment {
  prefix: string;
  datetime: string;
  confirmationNumber: string;
  code: string;
  message: string;
}

export const toString = (
  confirmationNumber: string,
  code: string,
  message: string
) => {
  return `(${PREFIX})(${dayjs().format(
    "YYYY-MM-DD HH:mm:ss"
  )})(${confirmationNumber})(${code})(${message})`;
};

export const toObject = (commentString: string): any => {
  const splitedComment = commentString
    .split(")")
    .map((x) => x.substring(1))
    .filter((x) => x !== "");
  if (splitedComment.length === 5) {
    const bpSystemGeneratedComment: IBpSystemGeneratedComment = {
      prefix: splitedComment[0],
      datetime: splitedComment[1],
      confirmationNumber: splitedComment[2],
      code: splitedComment[3],
      message: splitedComment[4],
    };
    return bpSystemGeneratedComment;
  }
};

export const parseBpCommentString = (comments: any[]) => {
  const commentArray = comments
    ?.map((comment) => {
      const text = comment.text;
      let jsonObject;
      try {
        jsonObject = JSON.parse(
          text.slice(text.indexOf("{"), text.lastIndexOf("}") + 1)
        );
        const codeParts = text.split("(");
        if (codeParts.length > 4) {
          const code = codeParts[4].slice(0, -1);
          jsonObject.code = code;
        }
      } catch (err) {}

      return jsonObject;
    })
    .filter((item) => item !== undefined);
  return commentArray || [];
};
